import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { CalendarCheck, ShieldCheck, ArrowRight } from "lucide-react";

const HIDDEN = ["/rdv-decouverte", "/admin", "/vendeur", "/dashboard", "/connexion", "/inscription", "/mon-compte"];

export const DiscoveryFloatingButton = () => {
  const { pathname } = useLocation();
  if (HIDDEN.some((p) => pathname.startsWith(p))) return null;
  return (
    <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.2 }} className="fixed bottom-5 right-5 z-[1000]">
      <Link to="/rdv-decouverte" data-testid="rdv-floating-btn" className="flex items-center gap-2 bg-[#E0C173] hover:bg-[#C9A85A] text-[#1B2A4A] font-semibold pl-4 pr-5 py-3 rounded-full shadow-[0_10px_30px_rgba(27,42,74,0.35)] hover:-translate-y-0.5 transition-all">
        <CalendarCheck className="w-5 h-5" strokeWidth={1.75} /> <span className="text-sm">RDV découverte gratuit</span>
      </Link>
    </motion.div>
  );
};

export const DiscoverySection = () => (
  <section data-testid="rdv-section" className="relative overflow-hidden bg-[#E0C173]">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 py-16 grid lg:grid-cols-[1.4fr_1fr] gap-10 items-center">
      <div>
        <span className="uppercase tracking-[0.25em] text-xs font-semibold text-[#1B2A4A]/70">Vous souhaitez céder votre entreprise ?</span>
        <h2 className="mt-3 font-display text-3xl sm:text-4xl text-[#1B2A4A] tracking-tight">Commencez par un RDV découverte</h2>
        <p className="mt-4 text-[#1B2A4A]/80 leading-relaxed max-w-xl">Un premier échange gratuit et sans engagement pour faire connaissance, comprendre votre entreprise et vos objectifs, et préparer la cession de votre affaire <strong className="text-[#1B2A4A]">en toute discrétion</strong>.</p>
        <div className="mt-5 flex items-center gap-2 text-sm text-[#1B2A4A]"><ShieldCheck className="w-4 h-4" strokeWidth={1.75} /> Confidentialité totale · Téléphone, visio ou au bureau d'Aix</div>
      </div>
      <div className="lg:justify-self-end">
        <Link to="/rdv-decouverte" data-testid="rdv-section-cta" className="inline-flex items-center gap-3 bg-[#1B2A4A] hover:bg-[#0D1629] text-white font-semibold px-9 py-5 rounded-full shadow-xl hover:-translate-y-0.5 transition-all text-base">
          <CalendarCheck className="w-5 h-5 text-[#E0C173]" strokeWidth={1.75} /> Demander mon RDV découverte <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  </section>
);
